import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  error: {
    color: theme.palette.extras.red,
    padding: theme.spacing(0, 2),
    fontSize: theme.typography.smallCaption.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    textAlign: "right"
  }
}));
